import * as tslib_1 from "tslib";
import Sockette from 'sockette';
import { CONNECTION_SOCKET_TIMEOUT, MAX_ATTEMPTS_SOCKET_RECONNECT } from './config.service';
import { SOCKET_URL, SERVER_URL } from 'src/environments/environment';
import { interval } from 'rxjs';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "./auth.service";
import * as i2 from "@angular/common/http";
export class SocketService {
    constructor(authService, http) {
        this.authService = authService;
        this.http = http;
        this.DEFAULT_TIMEOUT = 30;
        this.alerts = [];
        this.number_alerts = 0;
        this.isSocketConnected = false;
        this.connectSocket();
    }
    // Connect to web socket
    connectSocket() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var playerData = yield this.authService.getPlayerInitialData();
            if (!playerData)
                return null;
            this.webSocket = new Sockette(SOCKET_URL + "?token=" + this.authService.USER_TOKEN + "&u_id=" + playerData.user.id, {
                timeout: CONNECTION_SOCKET_TIMEOUT,
                maxAttempts: MAX_ATTEMPTS_SOCKET_RECONNECT,
                onopen: e => this.onConnectedSocket(e),
                onmessage: e => this.onMessage(e),
                onreconnect: e => console.warn('[Socket] Reconnecting...', e),
                onmaximum: e => console.warn('[Socket] Stop Attempting!', e),
                onclose: e => console.warn('[Socket] Closed!', e),
                onerror: e => console.error('[Socket] Error:', e)
            });
            // Reconnect 10s later
            //setTimeout(ws.reconnect, 10e3);
            return this.webSocket;
        });
    }
    onConnectedSocket(event) {
        this.isSocketConnected = true;
        console.debug('Socket conected!', event);
        this.startPingInterval();
        // On first connection try to reload recent rooms
        // this.events.publish('reload::rooms');
    }
    startPingInterval() {
        // Now update it every 45 seconds
        let reload = interval(1000 * 45);
        this.pingInterval = reload.subscribe(x => {
            this.pingToServer();
        });
    }
    pingToServer() {
        this.webSocket.send(JSON.stringify({ "action": "ping" }));
    }
    onMessage(event) {
        let data = JSON.parse(event.data);
        console.debug('Socket::Received:', data);
        if (data.notification)
            this.addNotification(data);
    }
    addNotification(notification) {
        var player_alert = {
            alert: {
                alert_type: notification.type,
                title: notification.title,
                description: notification.description,
                mission: notification.mission_id,
                order: notification.order_id,
                promotion: notification.promotion_id,
                response: notification.response_id,
                created: notification.created
            },
            id: notification.notification,
            was_seen: false
        };
        this.alerts.unshift(player_alert);
        this.number_alerts += 1;
    }
    getPlayerAlerts(offset = "0", limit = "5") {
        const url = SERVER_URL + '/alerts/player_alerts/';
        const params = { limit, offset };
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(url, { headers, params }).toPromise();
    }
    getNumberAlerts() {
        const url = SERVER_URL + '/alerts/get_number_of_alerts/';
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    markAsSeen(player_alert_id) {
        const url = SERVER_URL + '/alerts/mark_as_seen/';
        const headers = this.authService.getAuthHeaders();
        const body = { player_alert_id };
        return this.http.post(url, body, headers).toPromise();
    }
}
SocketService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SocketService_Factory() { return new SocketService(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.HttpClient)); }, token: SocketService, providedIn: "root" });
